'use strict';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {stateGoPostAuth} from '../actions';
import {logger} from './logger';

export const epics = [
  onStateGoPostAuth,
];

export const POST_AUTH_STATE_KEY = 'POST_AUTH_STATE';

onStateGoPostAuth.$inject = [
  'authCacheService',
];

export function onStateGoPostAuth(action$, store, dependencies) {
  return action$.ofType(stateGoPostAuth.TYPE)
    .do((action) => {
      dependencies.authCacheService.setItem(POST_AUTH_STATE_KEY, {
        toState: action.payload.toState,
        toParams: action.payload.toParams,
      });
    })
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onStateGoPostAuth'));
}



// WEBPACK FOOTER //
// ./src/js/auth/epics/stateGoPostAuth.js